/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q20Inputs */

const et_faq_q20 = /** @type {(inputs: Faq_Q20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millised on parimad SEO teenused Tallinnas?`)
};

const en_faq_q20 = /** @type {(inputs: Faq_Q20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are the best SEO services in Tallinn?`)
};

/**
* | output |
* | --- |
* | "What are the best SEO services in Tallinn?" |
*
* @param {Faq_Q20Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q20 = /** @type {((inputs?: Faq_Q20Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q20Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q20(inputs)
	return en_faq_q20(inputs)
});